import BannerRepository from "../BannerRepository"

export default class WhyPodiemInPageBanner extends BannerRepository {
    static schemaId = "why_us_banner"

    constructor() {
        super(WhyPodiemInPageBanner.schemaId)
    }
}
